export default "__VITE_ASSET__BxHd0HJa__"